export default "__VITE_ASSET__CW$93jwj__"